  //-----------------Images ----------------------------
  import  Phone  from 'public/icons/call2.svg';
  import  Tech  from 'public/icons/technical.svg';
  import  Video  from 'public/icons/video.svg';
  import  Face  from 'public/icons/user.svg';
  //-----------------Images ----------------------------

  export const ICONS = {
    PHONE:   'Phone',
    VIDEO:   'Video',
    VIDEOQA: 'Video Q&A',
    TECHTEST:  'Assessment',
    FACE2FACE: 'In-Person',
 }

export class SetIcons
{
    icons(type)
    {
        type = type.charAt(0).toUpperCase() + type.slice(1);
        switch(type) {
        case ICONS.PHONE:
            return <Phone/>;
        case ICONS.TECHTEST:
            return <Tech/>;
        case ICONS.VIDEO:
            return <Video/>;
        case ICONS.FACE2FACE:
            return <Face className="faceIcon"/>
        default:
            return '';
    }
  }
}
